import React from "react";
import AdditionalInformationComponent from "./AdditionalInformation.component";

const joinNameComponents = (nameComponents) => nameComponents.filter(name => name).join(' ');

const AddOrRemoveAsicAgentListComponent = (props) => {
  const { asicDetails, handleChange, setAsicDetails } = props;
  const handleNameChange = e => {
    setAsicDetails((changeOrder) => {
      const nameObject = {
        givenName1: changeOrder.givenName1,
        givenName2: changeOrder.givenName2,
        givenName3: changeOrder.givenName3,
        lastName: changeOrder.lastName,
        [e.target.name]: e.target.value,
      }

      const signerName = joinNameComponents([
        nameObject.givenName1,
        nameObject.givenName2,
        nameObject.givenName3,
        nameObject.lastName,
      ])

      return ({
        ...changeOrder,
        [e.target.name]: e.target.value,
        signerName,
      });
    });
  }
  return (
    <div className={props.isCardHeader ? "card" : "px-3"}>
      <form>
        <div className="container py-2">
          <div className="mb-3">
          <label className="form-label fw-bold">
            Form Signatory
          </label>
          </div>
          <div className="mb-3">
          <label className="form-label">
            Given name
          </label>
          <div className="row">
            <div className="col-md-4">
              <input
                type="text"
                className={
                  asicDetails?.givenName1 && asicDetails?.givenName1?.length > 0
                    ? "form-control is-valid"
                    : "form-control is-invalid"
                }
                name="givenName1"
                placeholder="Given name 1*"
                value={asicDetails?.givenName1 || ""}
                onChange={handleNameChange}
                required
              />
              {(!asicDetails?.givenName1 || asicDetails?.givenName1?.length === 0) && (
                <div className="text-danger py-3 px-3">
                  Given Name Required
                </div>
              )}
            </div>
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                name="givenName2"
                placeholder="Given/Middle name 2"
                value={asicDetails?.givenName2 || ""}
                onChange={handleNameChange}
              />
            </div>
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                name="givenName3"
                placeholder="Given/Middle name 3"
                value={asicDetails?.givenName3 || ""}
                onChange={handleNameChange}
              />
            </div>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">
            Last name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={
              asicDetails?.lastName && asicDetails?.lastName?.length > 0
                ? "form-control is-valid"
                : "form-control is-invalid"
            }
            name="lastName"
            placeholder="Last name"
            value={asicDetails?.lastName || ""}
            onChange={handleNameChange}
            required
          />
          {(!asicDetails?.lastName || asicDetails?.lastName?.length === 0) && (
            <div className="text-danger py-3 px-3">
              Last Name Required
            </div>
          )}
        </div>
        </div>
        <div
          className={
            props.isCardHeader
              ? "card-header accordion py-2"
              : " accordion py-2"
          }
          id="myAccordionAdditional "
        >
          <input
            className="form-check-input"
            type="checkbox"
            data-bs-toggle="collapse"
            data-bs-target="#collapseAdditionalInfo"
            id="gridAdditionalInfo"
            Name="additionalInfo"
            value="additionalInfo"
            onChange={(e) => props.handleChange(e, false, "")}
          />
          <label
            className={props.isCardHeader ? "form-check-label px-3" : "px-3"}
            for="gridAdditionalInfo"
          >
            Additional Info (Inc Partner / Manager / Client / Billing
            Information)
          </label>
        </div>
        <div
          id="collapseAdditionalInfo"
          className="accordion-collapse collapse"
        >
          <AdditionalInformationComponent
            handleChange={handleChange}
            asicDetails={asicDetails}
            setAsicDetails={setAsicDetails}
            companyProfile={props.companyProfile}
          />
        </div>
      </form>
    </div>
  );
};
export default AddOrRemoveAsicAgentListComponent;
